"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ppt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M12.0368 6.23102C11.0498 6.23102 10.2495 5.68127 10.2495 5.00252C10.2495 4.32377 11.0498 3.77402 12.0368 3.77402C13.0238 3.77402 13.8233 4.32377 13.8233 5.00252C13.8233 5.68127 13.0238 6.23102 12.0368 6.23102ZM11.112 19.944V6.82202H15.096C15.2438 6.82202 15.348 6.93227 15.348 7.08002V14.361C15.348 14.508 15.243 14.634 15.096 14.634H12.9V19.944C12.9 20.0918 12.7875 20.226 12.6398 20.226H11.3888C11.3155 20.2232 11.2461 20.1925 11.1947 20.1402C11.1433 20.088 11.1137 20.0181 11.112 19.9448V19.944ZM10.44 14.6333H8.93254C8.85965 14.6325 8.78985 14.6038 8.73761 14.5529C8.68538 14.5021 8.65473 14.4331 8.65204 14.3603V7.08002C8.65204 6.93227 8.78479 6.82202 8.93179 6.82202H10.44V14.634V14.6333Z", fill: color }));
}
exports["default"] = ppt;
//# sourceMappingURL=ppt.js.map